import { Image } from 'react-bootstrap'
import Logo from '../../../assets/images/logo.svg';
import { Link } from 'react-router-dom';


export const AuthHeader = () => {
    return (
        <>
            <h1 className="fw-normal h2 mb-0">Welcome to <Link to="/"><Image className="img-fluid text-blue" src={Logo} alt="Logo" width={122} height={46} /></Link></h1>
            <h6 className="fw-normal">Legacy Management Portal</h6>
        </>
    )
}
